export default __webpack_public_path__ + "static/media/jeeExam.42e101f0.png";